/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import $$ from '@/store/plugins/storage';
import { keepAliveList } from '@/constant';
import { getSessionUser } from '@/api';
var namespace = 'globalStore';
$$.setNamespace(namespace);
var state = {
  RUN_ENV: '',
  user: $$.get('user') || {},
  config: $$.get('config') || {},
  isInMain: $$.get('isInMain') || true,
  showHomebottomBar: true,
  pageReload: {},
  keepAliveList: keepAliveList,
  androidBack: {},
  createOrderDataCache: {},
  dateList: [{
    value: '1',
    name: '分钟'
  }, {
    value: '2',
    name: '小时'
  }, {
    value: '3',
    name: '天'
  }, {
    value: '4',
    name: '月'
  }],
  sysPhone: $$.get('sysPhone') || '400-6226-526',
  orderSearch: $$.get('orderSearch') || {},
  projectTabsIndexMap: $$.get('projectTabsIndexMap') || {},
  problemTabsIndexMap: $$.get('problemTabsIndexMap') || {},
  orderTabsIndexMap: $$.get('orderTabsIndexMap') || {}
};
var mutations = {
  _orderSearch: function _orderSearch(state, value) {
    state.orderSearch = value;
  },
  _projectTabsIndexMap: function _projectTabsIndexMap(state, value) {
    state.projectTabsIndexMap = value;
  },
  _problemTabsIndexMap: function _problemTabsIndexMap(state, value) {
    state.problemTabsIndexMap = value;
  },
  _orderTabsIndexMap: function _orderTabsIndexMap(state, value) {
    state.orderTabsIndexMap = value;
  },
  _sysPhone: function _sysPhone(state, value) {
    state.sysPhone = value;
  },
  _RUN_ENV: function _RUN_ENV(state, value) {
    state.RUN_ENV = value;
  },
  _user: function _user(state, value) {
    state.user = value;

    if (value) {
      var uid = btoa(value.id + '-' + value.enterpriseId);
      sessionStorage.setItem('[smy-vux] - wpkReporter/uid', uid);
    }
  },
  _config: function _config(state, value) {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        Vue.set(state.config, key, value[key]);
      }
    }
  },
  _isInMain: function _isInMain(state, value) {
    state.isInMain = value;
  },
  _showHomebottomBar: function _showHomebottomBar(state, value) {
    state.showHomebottomBar = value;
  },
  _pageReload: function _pageReload(state, value) {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        Vue.set(state.pageReload, key, value[key]);
      }
    }
  },
  _keepAliveList: function _keepAliveList(state, value) {
    if (state.keepAliveList.indexOf(value) === -1) {
      state.keepAliveList.push(value);
    } else {
      state.keepAliveList = state.keepAliveList.filter(function (item) {
        return item !== value;
      });
    }
  },
  _keepAliveListAdd: function _keepAliveListAdd(state, value) {
    if (state.keepAliveList.indexOf(value) === -1) {
      state.keepAliveList.push(value);
    }
  },
  _keepAliveListRemove: function _keepAliveListRemove(state, value) {
    state.keepAliveList = state.keepAliveList.filter(function (item) {
      return item !== value;
    });
  },
  _resetKeepAliveList: function _resetKeepAliveList(state) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    state.keepAliveList = value;
    setTimeout(function () {
      state.keepAliveList = keepAliveList;
    }, 60);
  },
  _androidBack: function _androidBack(state, value) {
    state.androidBack = value;
  },
  _createOrderDataCache: function _createOrderDataCache(state, data) {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        Vue.set(state.createOrderDataCache, key, data[key]);
      }
    }
  }
};
var actions = {
  _UpdateUserSesssion: function _UpdateUserSesssion(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      getSessionUser().then(function (res) {
        if (res.success) {
          commit('_user', res.data);
        }

        resolve(res);
      });
    });
  }
};
var getters = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};